/**
 * @封装用户会员各种信息文件
 * 需要在用户登录后才能调用这个文件，在访问接口asynProxy后调用有效
 * @author caizhenbo
 * create at 2015/4/11
 */

    var User = {};

    /**
     * 迅雷会员
     */
    User.isVip = function() {
        var paytype = parseInt(getCookie("vip_paytype"));
        var isvip = parseInt(getCookie("vip_isvip"));
        if ((isvip == 1 || isvip == 2) && paytype < 1000) {
            return 1;
        } else {
            return 0;
        }
    }
    /**
     * 迅雷会员
     */
    User.isStopVip = function() {
        //return true;
        var isvip = parseInt(getCookie("vip_isvip"));
        if (isvip == 2) {
            return true;
        } else {
            return false;
        }

    }

    /***
     * 迅雷迷你会员
     */
    User.isMiniVip = function() {
        var paytype = parseInt(getCookie("vip_paytype"));
        var isvip = parseInt(getCookie("vip_isvip"));
        var vas_type = parseInt(getCookie("vas_type"));
        if (this.isVip() && paytype < 1000 && vas_type == 1) {
            return 1;
        } else {
            return 0;
        }
    }

    /**
     * 普通会员非白金
     */
    User.isNormalVip = function() {
        var isvip = parseInt(getCookie("vip_isvip"));
        var vas_type = parseInt(getCookie("vas_type"));
        if (this.isVip() && vas_type == 2) {
            return 1;
        } else {
            return 0;
        }
    }
    /**
     * 白金会员
     */
    User.isPlatinumVip = function() {
        var paytype = parseInt(getCookie("vip_paytype"));
        var isvip = parseInt(getCookie("vip_isvip"));
        var vas_type = parseInt(getCookie("vas_type"));
        var level = parseInt(getCookie("vip_level"))
        if ((this.isVip() && vas_type == 3 ) || (this.isVip() && vas_type == 4 && level > 5 )) {
            return 1;
        } else {
            return 0;
        }
    }
    /**
     * 手机用户
     */
    User.isMobileVip = function() {
        var mobilevip = [3, 8, 9, 15, 103];
        var paytype = parseInt(getCookie("vip_paytype"));
        var isvip = parseInt(getCookie("vip_isvip"));
        var vas_type = parseInt(getCookie("vas_type"));
        if (this.isVip() && vas_type <= 3 && _in_array(paytype, mobilevip)) {
            return 1;
        } else {
            return 0;
        }
    }

    /**
     * 判断是否体验会员
     */
    User.isTiyan = function() {
        var isvip = getCookie('vip_isvip');
        var vip_paytype = getCookie('vip_paytype');
        if (this.isVip() == 1 && vip_paytype > 1000) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 判断是否钻石会员，先改为超级
     */
    User.isDiamondVip = function() {
        var isvip = getCookie('vip_isvip');
        var vas_type = getCookie('vas_type');
        if (this.isVip() == 1 && vas_type == 5) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 判断是否钻石会员
     */
    User.isSuperVip = function() {
        var isvip = getCookie('vip_isvip');
        var vas_type = getCookie('vas_type');
        if (this.isVip() == 1 && (vas_type == 5 || vas_type == 4)) {
            return true;
        } else {
            return false;
        }
    }


    /**
     * 判断是否快鸟会员
     */
    User.isKuainiaoVip = function() {
        var isvip = getCookie('vip_kn_isvip');
        return isvip == 1 ? true :false;
    }

    /**
     * 判断是否为过期会员
     */
    User.isOldvip = function() {
        var vip_level = getCookie("vip_level"); //会员级别;已登陆的非会员默认为0;
        var vip_isvip = getCookie("vip_isvip"); // 是否是 vip
        var vip_expiredate = getCookie("vip_expiredate") ;
        if (vip_level != null && vip_level != "" && vip_level != "0" && vip_isvip == 0) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * *
     * 判断是否是新用户
     */
     User.isNewUser = function(){
        var isVip = getCookie('vip_isvip'),
            level = getCookie('vip_level');
        if(isVip == 0 && level == '' || level == 0){
            return 1;
        }
        return 0 ;
    }

    /**
     * 判断是否为靓号
     */
    User.isGoodnum = function() {
        var vip_isgoodnum = getCookie("vip_is_good_number")
        if (vip_isgoodnum != null && vip_isgoodnum != "" && vip_isgoodnum == "1") {
            return true;
        } else {
            return false;
        }
    }

    /**
     * 是否会员子帐号
     */
    User.isChild = function() {
        var ischild = parseInt(getCookie("ischild"));
        if (ischild == "1" || getCookie("vip_ischild") == 1) {
            return 1;
        } else {
            return 0;
        }
    }
    /**
     * 是否为年费会员
     */
    User.isYearVip = function() {
        var isyear = parseInt(getCookie("vip_isyear"));
        if (isyear == "1") {
            return 1;
        } else {
            return 0;
        }
    }

    /**
     * 是否为2009年10月前购买白金会员的历史用户
     */
    User.isHistoryVip = function() {
        var ishistory = parseInt(getCookie("history"));
        if (ishistory == "1") {
            return 1;
        } else {
            return 0;
        }
    }

    /**
     * 获取用户的昵称
     */
    User.nickname = function() {
        var nickname = getCookie("vip_nickname") ? getCookie("vip_nickname") : getCookie("usernick");
        return nickname;
    }

    /*
     *迅雷用户名
     */
    User.xlUsername = function() {
        var usrname = getCookie("usrname");
        var Usernewno = getCookie("Usernewno");
        if (usrname != '' && usrname != '0') {
            return usrname;
        }
        return Usernewno;

    }
    /**
     * 获取用户的头像
     */
    User.avatar = function() {

        return 'http://img.user.kanimg.com/usrimg/' + getCookie('userid') + '/100x100';
    }

    /**
     *用户的成长值
     */
    User.daily = function() {
        var daily = getCookie('vip_daily');
        return daily;
    }

    /**
     *用户等级
     *
     */
    User.level = function() {
        var level = getCookie('vip_level');
        if (level == 'level' || level == '') {
            level = 0;
        }
        return level;
    }

    /**
     * 用户图标url
     */
    User.iconUrl = function(){
        var iconUrl = '';
        if(User.isSuperVip()){
            iconUrl = 'http://vip.xunlei.com/vip_service/supervip/';
        }else{
            iconUrl = 'http://vip.xunlei.com/vip_service/mycenter/myvip.html';
        }
        return iconUrl;
    }

    /*
     **返回会员身份判断
     * return 0:非会员:1：迷你会员；2:普通会员；3：白金会员；4:钻石会员；
     */
    User.identity = function() {
        if (this.isMiniVip()) {
            return 1;
        }
        if (this.isNormalVip()) {
            return 2;
        }
        if (this.isPlatinumVip()) {
            return 3;
        }
        if (this.isDiamondVip()) {
            return 4;
        }
        if(this.isSuperVip()){
            return 5;
        }
        return 0;
    }

    /*
     **会员有效期
     */
    User.expiredate = function() {
        var expiredate = getCookie('vip_expiredate');
        if (expiredate) {
            return expiredate;
        } else {
            return '无';
        }
    }

    /*
     **用户会员图标
     **return 用户快鸟会员身份图标class
     */
     User.knIcon = function(){
        var iconClass = '';
        if (getCookie('vip_kn_isvip') == 1) {
            iconClass = 'icvip ickn';
        }else{
            iconClass = 'icvip icknhui';
        }

        return iconClass;
    }

    /*
     *用户会员图标
     * return 用户会员身份图标class
     */
    User.vipIcon = function(){
        var id = parseInt(getCookie('vas_type'));
        var level = this.level();
        var iconClass = '';
        switch(id){
            case 1:
               iconClass ='icvip icvip0'+ level + 'hui';
                break;
            case 2:
                iconClass ='icvip icvip0'+ level;
                break;
            case 3:
                iconClass ='icvip icgoldvip icgold0'+ level;
                break;
            case 4:
                if(level >= 6){
                    iconClass ='icvip icgoldvip icgold0'+ level;
                }else{
                    iconClass ='icvip icsuper0'+ level;
                }
                // iconClass ='icvip iczuan icz0'+ level;
                break;
            case 5:
                iconClass ='icvip icsuper0'+ level;
                break;
            default:
                iconClass ='icvip icvip0'+ level ;
                break;
        }
        if(getCookie('vip_isvip') == 0){
            //增加快鸟非会员显示快鸟图标
            iconClass = iconClass + 'hui';
        }
        return iconClass;
    }

    /*
     *用户会员身份
     * return 用户会员名称
     */
    User.vipName = function(){
        var name = '非会员';
        var id = parseInt(getCookie('vas_type'));
        var level = this.level();
        if(!User.isVip() && !User.isOldvip()){
            return name;
        }
        switch(id){
            case 1:
            case 2:
                name = '迅雷普通会员';
                break;
            case 3:
                if(level >= 6){
                    name = '迅雷白金钻石会员';
                }else{
                    name = '迅雷白金会员';
                }
                break;
            case 4:
                if(level >= 6){
                    name = '迅雷白金钻石会员';
                }else{
                    name = '迅雷超级会员';
                }
                // iconClass ='icvip iczuan icz0'+ level;
                break;
            case 5:
               name = '迅雷超级会员';
                break;
            default:
                name = '迅雷会员';
                break;
        }
        name = name + 'VIP' + level;
        if(getCookie('vip_isvip') == 0){

            name = '过期' + name ;
        }
        return name;
    }

    /*
     *用户到期时长剩余多少个月，向下取整
     * return 剩余月份
     */
    User.levelMonth = function(){
        var isVip = getCookie('vip_isvip'),
            expiredays = getCookie('vip_expiredays');
        if(isVip == 1){
            return Math.floor(expiredays/31);
        }
        return 0 ;
    }

    User.payText = function(){

        if(User.isStopVip()){
            return '激活会员';
        }
        return getCookie('pay_tips') || '开通白金会员';
    }

    function _in_array(val, arr) {
        for (var i in arr) {
            if (arr[i] == val) {
                return true;
            }
        }
        return false;
    }

    //initUserInfo();
export default User;



// WEBPACK FOOTER //
// ./src/common/user.js